import React from 'react';
import { useTranslations } from 'js/hooks/i18n';

export const I18n = ({
    tKey = '',
    replacers = [],
    defaultValue,
    className = '',
    t
}) => {
    const defaultTranslate = useTranslations();
    const tt = t || defaultTranslate;
    const tValue = tt(tKey, replacers, defaultValue);

    return <span className={className} dangerouslySetInnerHTML={{ __html: tValue }} />;
};

export default I18n;
